import IconContainer from '@/components/IconContainer'

export default function IconColorMeter(props) {
  return (
    <IconContainer
      {...props}
      width="40"
      height="20"
      ariaLabel="Meter Icon"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        d="M19.9999 4C16.7258 4 13.6869 4.98131 11.1539 6.66547C6.83766 9.53529 3.99994 14.4367 3.99994 20H-6.10352e-05C-6.10352e-05 13.0415 3.55528 6.91424 8.93921 3.33453C12.1081 1.2276 15.9137 0 19.9999 0C24.0862 0 27.8918 1.2276 31.0607 3.33453C36.4446 6.91424 39.9999 13.0415 39.9999 20H35.9999C35.9999 14.4367 33.1622 9.53529 28.846 6.66547C26.313 4.98131 23.2741 4 19.9999 4Z"
        fill="#01B292"
      />
      <path
        d="M19.9999 4C16.7258 4 13.6869 4.98131 11.1539 6.66547L8.93921 3.33453C12.1081 1.2276 15.9137 0 19.9999 0C24.0862 0 27.8918 1.2276 31.0607 3.33453C36.4446 6.91424 39.9999 13.0415 39.9999 20H35.9999C35.9999 14.4367 33.1622 9.53529 28.846 6.66547C26.313 4.98131 23.2741 4 19.9999 4Z"
        fill="#00A3FF"
      />
      <path
        d="M36 20C36 14.4367 33.1623 9.53529 28.846 6.66547L31.0607 3.33453C36.4446 6.91424 40 13.0415 40 20H36Z"
        fill="#FF6867"
      />
    </IconContainer>
  )
}
